/** Primary font used for all body and UI text across the site */
export const FONT_FAMILY = 'Space Grotesk' as const;

const theme = {
  themeColor: '#AFC3C1',
  fontColor: '#1B2B3A',
  fontFamily: FONT_FAMILY,
} as const;

export default theme;
